(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cancel-order-form"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      var form = document.getElementById('cancel-order-form');
      var submitBtn = document.getElementById('comfy-submit-btn');
      var statusDiv = document.getElementById('comfy-form-status');
      var confirmationDiv = document.getElementById('comfy-confirmation');
      var iframe = document.getElementById('comfy-iframe');
      var bodyField = document.getElementById('comfy-body-field');

      if (!form) return;

      // Helper: show status message
      function showStatus(message, type) {
        statusDiv.style.display = 'block';
        statusDiv.textContent = message;
        statusDiv.className = 'comfy-status-message ' + type;
        clearTimeout(window.comfyStatusTimeout);
        window.comfyStatusTimeout = setTimeout(function() {
          statusDiv.style.display = 'none';
        }, 6000);
      }

      // Listen for iframe load (form submission complete)
      iframe.addEventListener('load', function() {
        // Form was submitted via iframe - show confirmation
        form.style.display = 'none';
        confirmationDiv.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = '✅ Confirmed';
        statusDiv.style.display = 'none';
        
        // Update URL to show submitted state
        if (window.history && window.history.replaceState) {
          var newUrl = window.location.pathname + '?submitted=true';
          window.history.replaceState({}, '', newUrl);
        }
      });

      // Handle form submission
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        // Validate
        var name = document.getElementById('comfy-customer-name').value.trim();
        var email = document.getElementById('comfy-customer-email').value.trim();
        var order = document.getElementById('comfy-order-number').value.trim();

        if (!name || !email || !order) {
          showStatus('Please fill in all required fields (Name, Email, Order number).', 'error');
          return;
        }

        if (!email.includes('@') || !email.includes('.')) {
          showStatus('Please enter a valid email address.', 'error');
          return;
        }

        // Disable button, show loading
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending ...';
        statusDiv.style.display = 'none';
        confirmationDiv.style.display = 'none';

        // Build email body
        var reason = document.getElementById('comfy-reason').value.trim();
        var timestamp = new Date().toLocaleString('nl-NL', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        });

        var bodyLines = [];
        bodyLines.push('--- Cancellation Request ---');
        bodyLines.push('Timestamp: ' + timestamp);
        bodyLines.push('Name: ' + name);
        bodyLines.push('Email: ' + email);
        bodyLines.push('Order number: ' + order);
        bodyLines.push('Reason: ' + (reason || '(not provided)'));
        bodyLines.push('');
       // bodyLines.push('We confirm receipt of your cancellation request.');
       // bodyLines.push('We will process this within 14 days.');
       // bodyLines.push('Questions? Email info@comfykidz.nl');

        // Set the body field
        bodyField.value = bodyLines.join('\n');

        // Add a timestamp field as well
        var timestampField = document.createElement('input');
        timestampField.type = 'hidden';
        timestampField.name = 'contact[timestamp]';
        timestampField.value = timestamp;
        form.appendChild(timestampField);

        // Submit the form to the iframe
        form.target = 'comfy-iframe';
        form.submit();

        // Set a timeout in case the iframe doesn't trigger
        setTimeout(function() {
          if (form.style.display !== 'none') {
            // If form is still visible after 5 seconds, assume success
            form.style.display = 'none';
            confirmationDiv.style.display = 'block';
            submitBtn.disabled = false;
            submitBtn.textContent = '✅ Confirmed';
            statusDiv.style.display = 'none';
          }
        }, 5000);
      });

      // Check if we're already in a submitted state
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('submitted') === 'true') {
        form.style.display = 'none';
        confirmationDiv.style.display = 'block';
      }
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
